export default {
  team: 'Team',
  searchPlaceholder: 'Search by name',
  ADMIN: 'Admin',
  MANAGER: 'Manager',
  CASHIER: 'Cashier',
  addEmployee: 'Add team member',
  BUSINESS_MANAGER: 'Manager',
  BUSINESS_CASHIER: 'Cashier',
  BUSINESS_ADMINISTRATOR: 'Administrator',
  BUSINESS_SALES_AGENT: 'Sales Agent',
  email: 'Email',
  phoneNumber: 'Phone number',
  terminal: 'Terminal',
  documentType: 'Document type',
  documentNumber: 'Document number',
  authority: 'Authority',
  position: 'Position',
  role: 'Role',
  account: 'Account',
  all: 'All',
  roles: 'Roles',
  owner: 'Owner',
  executive: 'Executive',
  editEmployee: 'Edit team member',
  getAccessCode: 'Get access code',
  getAccessCodeFor: 'Get access code for {{name}}',
  accessCodeMessage: 'Please communicate code to the user. You will not be able to view it again.',
  reportsTo: 'Reports to',
  cashierAgentAt: 'Cashier/agent at',
  managesLocations: 'Manages locations',
};
